import React,{useState,useEffect} from 'react'
import {Paper,Table,TableBody,TableCell,TableContainer,TableHead,TablePagination,TableRow,Dialog,DialogTitle,DialogActions,DialogContent,DialogContentText,Button} from '@mui/material';
import { BASE_URL } from '../../utils/config';
import Loading from "../loading";
import Sidebar from '../sidebar';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const  DeliveryTab  = () => {

 
  const columns = [

    { id: "S.No", label: "S.No", minWidth: 40 },
    { id: 'SignalType', label: 'Stock Name', minWidth: 120},
    { id: 'SignalStatus', label: 'Status', minWidth: 75 },
    { id: 'datetime', label: 'Date Time', minWidth: 110 },
    { id: 'PriceAtSignal', label: 'PriceAtSignal', minWidth: 90 },
    { id: 'Current_cmp', label: 'CurrentCMP', minWidth: 110},
    { id: 'SignalStopLoss', label: 'SignalStopLoss', minWidth: 70 },
    { id: 'lot_size', label: 'LotSize', minWidth: 80 },
    { id: 'SignalFinal', label: 'SignalFinal', minWidth: 100 },
    { id: 'OptionAtMoney', label: 'StrikePrice', minWidth: 80 },
    { id: 'SignalDT', label: 'SignalDT', minWidth: 110 },
    { id: 'LastCheckedDT', label: 'LastCheckedDT', minWidth: 110 },
    { id: 'HighAfterSignal', label: 'HA Signal', minWidth: 70 },
    { id: 'HighDT', label: 'HighDT', minWidth: 110 },
    { id: 'LowAfterSignal', label: 'LA Signal', minWidth: 90 },
    { id: 'LowDT', label: 'LowDT', minWidth: 110 },
    // { id: 'SLTrigger', label: 'SLTrigger', minWidth: 50 },
    // { id: 'SLTriggerDT', label: 'SLTriggerDT', minWidth: 130 },
    // { id: 'ActionAtSL', label: 'ActionAtSL', minWidth: 90 },
    { id: 'symbol', label: 'Symbol', minWidth: 100 },
    { id: 'close', label: 'Close', minWidth: 70 },
    { id: 'open', label: 'Open', minWidth: 70 },
    { id: 'high', label: 'High', minWidth: 70 },
    { id: 'low', label: 'Low', minWidth: 70 },
    { id: 'volume', label: 'Volume', minWidth: 80 },
    { id: 'Expiry', label: 'Expiry', minWidth: 110 },
    { id: 'InstrumentToken', label: 'Ins Token', minWidth: 100 },
    { id: 'ExchangeToken', label: 'Exc Token', minWidth: 100 },  
    { id: 'IndexStopLoss', label: 'IndexStopLoss', minWidth: 80 },
    { id: 'close_sma12', label: 'C_sma12', minWidth: 90 },
    { id: 'close_sma26', label: 'C_sma26', minWidth: 90 },
    { id: 'close_sma200', label: 'C_sma200', minWidth: 90 },
];
const [authdata, setAuthData] = useState({
  username: '',
  password: ''
});
const [cmp,setCMP]= useState('')
const [loading, setLoading] = useState(false);
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(25);
const [startIndex, setStartIndex] = useState(0);
const [endIndex, setEndIndex] = useState(25);
const [openDialog, setOpenDialog] = useState(false);
const [selectedRecord, setSelectedRecord] = useState({});
const [authenticationOpen, setAuthenticationOpen] = useState(false);
const [SLEditOpen, setSLEditOpen] = useState(false);
const [BookPorL,setBookPorL]= useState('')
const [newsl,setNewSL]=useState('');
const [showInvalidPasswordAlert, setShowInvalidPasswordAlert] =
useState(false);
const [Errorshow,setErrorShow]=useState(false);
const [showError,setShowError]=useState(false);
const [Errormessage,setErrorMessage]= useState('');

const passwordRegex =
/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+[\]{};:<>?]{8,}$/;

const [data, setData] = useState([]);
const [oldData,setOldData] = useState([]);
const [newRecords, setNewRecords] = useState([]);

let count = 0; 
const [recordcolor,setRecordColor] = useState(0)
 
useEffect(() => {
    if(data.length  > 0){
      if(oldData.length>0){ 
        setRecordColor(1)
      }
    const newRecord = data.filter(record => !oldData.some(d => d.id === record.id));
  
    console.log("newRecords", newRecord);
  
    setNewRecords(newRecord)
    setOldData(data)
    }
  }, [data]);
 
  // to fetch data from api in every 1 minute
useEffect(() => {
  const fetchDataInterval = setInterval(async() => {
   
    await fetchDataForAllTabs(); 
  }, 60000); //0,000 milliseconds = 1 minute

  // Initial fetch when count is 0
  if (count === 0) {
  
    fetchDataForAllTabs();
    count += 1;
  }

  // Cleanup the interval on component unmount
  return () => clearInterval(fetchDataInterval);
}, []);

// to fetch data from api when page is loaded
  const fetchDataForAllTabs = async () => {
  console.log("fetch record details")
    try {
     
       
             await fetch(`${BASE_URL}/getAllReportList/delivery`, {
                method: 'GET'
            })
                .then(response => response.json())
                .then(res => {
                    // Process the API response data
                    // console.log(res);
                    if (res.success === true) {
                      console.log("res.data", res.data);

                      let newData = res.data;
             console.log("newdate length",newData.length)
      

        setData(newData); 
                     
                    }else{
                    console.log("data not found");
                    setErrorMessage(`Error: ${res.message}`);
                    setShowError(true);
                    setTimeout(() => {
                      
                      setShowError(false);
                      setErrorMessage('');
                    }, 2000);
                    }
          
                })
                .catch(error => {
                    // Handle errors
                    console.error('Error fetching data:', error);
                    // data.push(tab)
                });   
        
    
   

    } catch (error) {
      setErrorMessage(`Error: ${error.message}`);
      setShowError(true);
      setTimeout(() => {
        
        setShowError(false);
        setErrorMessage('');
      }, 2000);
      console.error('Error fetching data:', error);
    }
  };

// to handle close dialog box
const handleClose = () => {
  setOpenDialog(false);
};

// to handle page change in table
const handleChangePage = (event, newPage) => {
  setPage(newPage);
  let startindex = newPage * rowsPerPage;
  console.log("startindex", startindex)
  let endindex = Math.min(startindex + rowsPerPage, data.length)
  console.log("endindex", endindex)
  setStartIndex(startindex);
  setEndIndex(endindex)

};

// to handle rows per page in table
const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(+event.target.value);
  setEndIndex(+event.target.value);
  setStartIndex(0);
  setPage(0);
};

// to format date and time in table
const formatDateTime = (row) => {
  let date = new Date(row.datetime);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  // Format the date and time
  const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;

  //  console.log(formattedDate);
  return formattedDate
}

// to format expiry date in table
const formatExpiry = (row) => {



  let date = new Date(row.Expiry);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  // Format the date and time
  const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;

  //  console.log(formattedDate);
  return formattedDate
}



// to handle show popup for book profit and book loss
const hyperLinkStockName = async(row) => {
  console.log("rowData", row);

  if(!row.InstrumentToken){
    setErrorMessage('Instrument token not found.')
    setShowError(true)
    setTimeout(()=>{
      setShowError(false) 
      setErrorMessage('')  
    } ,3000)  
    console.log("instrument token not found")
    return
  }
  setSelectedRecord(row);
  setLoading(true)
  await fetch(`${BASE_URL}/getcmpdashboard/${row.InstrumentToken}`, {
    method: "GET",
  })
    .then((res) => res.json())
    .then((res) => {
      console.log("res", res);
      if (res.success == true) {

      console.log("auth pass") 
      setCMP(res.data)
          let value = res.data - row.PriceAtSignal
          value = value.toFixed(2);
          setBookPorL(value)

      console.log("print bookPorL",BookPorL)
      setOpenDialog(true);
      setLoading(false)

      }
      else{
        console.log("CMP not found.")
        setLoading(false)
        setErrorMessage(`Error: ${res.message}`);
        setShowError(true);
        setTimeout(() => {
          
          setShowError(false);
          setErrorMessage('');
        }, 2000);
      }
    }).catch((error)=>{
     console.log("error",error)
     setLoading(false)
     setErrorMessage(`Error: ${error.message}`);
     setShowError(true);
     setTimeout(() => {
       
       setShowError(false);
       setErrorMessage('');
     }, 2000);
    })

}

// handle stock loss change
const handleStockLossChange = (row) => {
  console.log("row Data", row);
  setSelectedRecord(row);
  setNewSL(row.SignalStopLoss)
  setAuthenticationOpen(true);
}

// handle close authentication dialog box
const handleAuthenticationClose = () => {
  setAuthenticationOpen(false)
}

// handle close stop loss edit dialog box
const handleSLEditClose = () => {
  setSLEditOpen(false)
}


// handle authentication submit
const handleAuthSubmit = (e) => {
  e.preventDefault();
  console.log("inside auth handler");
  setLoading(true)
  try {
  if (!passwordRegex.test(authdata.password)) {
      setShowInvalidPasswordAlert(true);
      setTimeout(() => {
        setShowInvalidPasswordAlert(false);
      }, 2000);
    } else {
      if ( !authdata.password || !authdata.username) {
        setErrorMessage("Please fill all the fields.");
        setErrorShow(true)
        setTimeout(() => {
          setErrorShow(false)
          setErrorMessage('')
        }, 2000);
        return;
      }


      let body = JSON.stringify({ AuthDetails: authdata });
      fetch(`${BASE_URL}/authsledit`, {
        method: "POST",
        body,
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          console.log("res", res);
          if (res.success === true) {
          console.log("auth pass")   
          setLoading(false)
          setAuthenticationOpen(false)
          setSLEditOpen(true)
          }else{
            setLoading(false) 
            setErrorMessage(res.message)
            setErrorShow(true)
            setTimeout(() => {
              
              setErrorShow(false) 
              setErrorMessage('')
            }, 1500);
          }
        }) 
    }
  } catch (error) {
    console.log("error", error);
    setLoading(false) 
    
    setErrorMessage(`Error: ${error.message}`);
    setErrorShow(true)
    setTimeout(() => {
              
      setErrorShow(false) 
      setErrorMessage('')
    }, 1500);
  }


}

// handle stop loss change submit
const handleSLChangeSubmit = (e) => {
  e.preventDefault();
  console.log("inside sl handler",newsl);
  console.log("inside sl selected record",selectedRecord);
 try{ 

  if(newsl === ''){
    setErrorMessage("Please fill all the fields.");
    setErrorShow(true)
    setTimeout(() => {
      setErrorShow(false)
      setErrorMessage('')
    }, 2000);
    return;
  }
  fetch(`${BASE_URL}/editsl?id=${selectedRecord.id}&sl=${newsl}`, {
    method: "PUT",
  })
    .then((res) => res.json())
    .then((res) => {
      console.log("res", res);
      if(res.success === true) {
      console.log("Sl edit SUccess")   
      setSLEditOpen(false)
      fetchDataForAllTabs();
   
      setTimeout(() => {
        setLoading(false) 
      }, 2000);
      }else{
        setLoading(false) 
        setErrorMessage(res.message)
        setErrorShow(true)
        setTimeout(() => {
          
          setErrorShow(false) 
          setErrorMessage('')
        }, 1500);
      }
    })
  }catch(error){
    console.log("error", error);
    setLoading(false) 
    
    setErrorMessage(`Error: ${error.message}`);
    setErrorShow(true)
    setTimeout(() => {          
      setErrorShow(false) 
      setErrorMessage('')
    }, 1500);
  }
}

// handle chnge in authentication input fields
const handleAuthChange = (e) => {
  const { name, value } = e.target;
  setAuthData((prevState) => {
    const newState = {
      ...prevState,
      [name]: value
    };


    return newState;
  });
};

// handle submit for book profit and book loss
const handleBookProfitOrLoss = (e)=>{
e.preventDefault();

try{ 



  let date = new Date();

 if(!cmp){
  setErrorMessage('CMP not found.')
  setShowError(true)
  setTimeout(()=>{
    setShowError(false) 
    setErrorMessage('')  
  } ,3000)  
  console.log("cmp not found")
  return
 }

fetch(`${BASE_URL}/bookprofitorcloseposition?id=${selectedRecord.id}&cmpPrice=${cmp}`, {
  method: "PUT",
})
  .then((res) => res.json())
  .then((res) => {
    console.log("res", res);
    if(res.success === true) {
    console.log("Book Profit or Close Position edit SUccess")   
    setOpenDialog(false);
    fetchDataForAllTabs();
 
    setTimeout(() => {
      setLoading(false) 
    }, 2000);
    }else{
      setLoading(false) 
      setErrorMessage(res.message)
      setErrorShow(true)
      setTimeout(() => {
        
        setErrorShow(false) 
        setErrorMessage('')
      }, 1500);
    }
  })
}catch(error){
  console.log("error", error);
  setLoading(false) 
  
  setErrorMessage(`Error: ${error.message}`);
  setErrorShow(true)
  setTimeout(() => {          
    setErrorShow(false) 
    setErrorMessage('')
  }, 1500);
}
}

// handle change in stop loss input field
const handleSLChange = (e)=>{
   let value = e.target.value
  if (/^\d*\.?\d{0,2}$/.test(value)){
   setNewSL(value) 
  }
  else{
    setErrorMessage('Numeric input with 2 decimal places (0-9).')
    setErrorShow(true)
    setTimeout(()=>{
      setErrorShow(false) 
      setErrorMessage('')  
    } ,3000)  
    console.log("SL hold 2point value")
  }
}

// handle calculation of current cmp profit form given price at signal
const calCurrComp = (row)=>{
    
  let value = row.Current_cmp - row.PriceAtSignal
  value = value.toFixed(2);
  let percentDifference = ((value / row.PriceAtSignal) * 100).toFixed(2);
  // console.log("value",value)
  return(
    <div style={{display:'flex',flexDirection:'column'}}>
    {row.Current_cmp === '' ? (
      <span>{row.Current_cmp}</span>
  ) : (
      <div>
          <span>{row.Current_cmp}</span>
          <div>
              <span>
                  {value >= 0 ? <ArrowDropUpIcon fontSize="small" sx={{ color: 'green' }} /> : <ArrowDropDownIcon fontSize="small" sx={{ color: 'red' }} />}
              </span>
              <span style={{ color: value >= 0 ? 'green' : 'red' }}>{`${Math.abs(value)}(${percentDifference}%)`}</span>
          </div>
      </div>
  )}
    </div>
)
}





  return (
    <div>
    <Sidebar/>
    <div className='Dashboard-container container-block'>
    <div className='deliveryTab'>
    <h6>Delivery Tab</h6>
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
     <TableContainer sx={{ maxHeight: 400}}>
       <Table style={{margin: 0}} stickyHeader aria-label="sticky table">
         <TableHead >
           <TableRow>
             {columns.map((column,index) =>(
                  <TableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    textAlign:'center',
                    minWidth: column.minWidth,
                    backgroundColor: '#23499E',
                    padding:0,
                    color: '#fff',
                    fontWeight: 'bold',
                    zIndex:column.id === "S.No"||column.id === "SignalType"?20:5,left:column.id === "S.No"?0 :column.id === "SignalType"?40:undefined

                  }}
                >
                  {column.label}
                </TableCell>
             ))}
           </TableRow>
         </TableHead>
         <TableBody>
           {data
            .slice(startIndex,endIndex)
             .map((row,index) => {
              const isNewRecord = newRecords.some(newRecord => newRecord.id === row.id);
               return (
                 <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                   {columns.map((column) => {
                     const value = row[column.id];
                     return (
                       <TableCell 
                       style={{position:'sticky',backgroundColor: recordcolor == 0 ? '#fff' :isNewRecord ? 'lightgreen' :'#fff', zIndex:column.id === "S.No"||column.id === "SignalType"?10:1,left:column.id === "S.No"?0 :column.id === "SignalType"?40:undefined}}
                       class="table-cell-deliveryTab" 
                       key={column.id} 
                       align={column.align}
                       >
                          {column.id === "S.No"
                                    ? index + 1
                                    :column.id === 'SignalType'
                                    ? <div style={{color:'blue',cursor:'pointer'}} onClick={() => hyperLinkStockName(row)}>
                                      {value}
                                    </div>
                                     : column.id === 'SignalStopLoss'
                                     ? <div style={{ color: 'blue', cursor: 'pointer' }} onClick={() => handleStockLossChange(row)}>
                                       {value}
                                     </div>
                                    :column.id  ==="datetime"
                                    ? formatDateTime(row)
                                    :column.id === "Expiry"
                                    ? formatExpiry(row)
                                    : column.id === "Current_cmp"
                                    ? calCurrComp(row)
                                    : value
                                    }
                       </TableCell>
                     );
                   })}
                 </TableRow>
               );
             })}
         </TableBody>
       </Table>
     </TableContainer>
     <TablePagination
       rowsPerPageOptions={[25, 50,75,100]}
       component="div"
       count={data.length}
       rowsPerPage={rowsPerPage}
       page={page}
       onPageChange={handleChangePage}
       onRowsPerPageChange={handleChangeRowsPerPage}
     />
    </Paper>

      {/* dialog for book profit and book loss */}
      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
         {BookPorL >= 0? 'BOOK PROFIT':'BOOK LOSS'}
        </DialogTitle>
        <DialogContent style={{width:'350px'}}>
        <div className="Authmain">
              <div className="Authcontent">

              <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
              <p>CMP:</p>   
                <div>
                <span>{cmp} {BookPorL >= 0?<ArrowDropUpIcon fontSize="large" color="success"/>:<ArrowDropDownIcon fontSize="large" sx={{ color: 'red' }}/>}</span>  
                <span style={{color: BookPorL >= 0? 'green':'red'}}>{BookPorL}</span>
                </div>
              </div>
              </div>
        </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleBookProfitOrLoss}>
          {BookPorL >= 0? 'Book Profit':'Close Position'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* dialog for authencation */}
      <Dialog
        open={authenticationOpen}
        onClose={handleAuthenticationClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        
      >
        <DialogTitle id="alert-dialog-title">
          {"Authentication to change SL"}
        </DialogTitle>
        {loading ? (
            <div
              style={{
                position: "fixed", 
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}

            >
              <Loading />
            </div>
          ) : null}
        <form onSubmit={handleAuthSubmit}>
        <DialogContent style={{width:'450px'}}>
            <div className="Authmain">
              <div className="Authcontent">
              {Errorshow?
               <span style={{ color: "red" }}>
                 {Errormessage}
                </span>
:null} 
              <div>
                <p>Username :<span className='asterisk'>*</span></p>
                <input value={authdata.username} type="email" id="username" name="username" required onChange={handleAuthChange} />
              </div>

              {showInvalidPasswordAlert && (
                <span>
                Please enter a valid password. Passwords must be at least 8
                characters long and contain at least one letter, one digit, and
                may include special characters.
                </span>
            )}
              <div>
                <p>Password :<span className='asterisk'>*</span></p>
                <input value={authdata.password} type="password" id="password" name="password" required onChange={handleAuthChange} />
              </div>
              </div>
            </div>
        </DialogContent>
        <DialogActions style={{textAlign:'end'}}>
          <Button className='btn-cancel' onClick={handleAuthenticationClose}>Cancel</Button>
          
          <input type="submit" value="Submit" className='btn-submit'
            style={{ width:'70px',borderRadius:'5px',cursor:authdata.username === '' || authdata.password === ''?'not-allowed':'pointer'}}
            disabled={authdata.username === '' || authdata.password === ''} />
        </DialogActions>
        </form>
      </Dialog>

      {/* dialog for sl change  */}

      <Dialog
        open={SLEditOpen}
        onClose={handleSLEditClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Enter New Stop Loss"}
        </DialogTitle>
        <DialogContent style={{width:'450px'}}>
        {loading ? (
            <div
              style={{
                position: "fixed", 
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}

            >
              <Loading />
            </div>
          ) : null}

        <div className="Authmain">
              <div className="Authcontent">
              {Errorshow?
               <span style={{ color: "red" }}>
                 {Errormessage}
                </span>
:null} 
              <div>
                <p>SL:<span className='asterisk'>*</span></p>
                <input value={newsl} type="number" id="sl" name="sl" required onChange={handleSLChange} />
              </div>
             
              </div>
            </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSLEditClose}>cancel</Button>
          <Button onClick={handleSLChangeSubmit} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </Dialog>

       {/* To show Error messages */}

          <Dialog
                     open={showError}
                     onClose={() => {
                       setShowError(false);
                     }}
                     aria-labelledby="alert-dialog-title"
                     aria-describedby="alert-dialog-description"
                   >
                     <DialogContent>
                       <DialogContentText id="alert-dialog-description">
                         <div>
                           <span>
                             <i
                               className="pi pi-exclamation-circle"
                               style={{ color: "#FF6060" }}
                             />
                             <br />
                             {Errormessage}
                           </span>
                         </div>
                       </DialogContentText>
                     </DialogContent>
                   </Dialog>
   </div>
   </div>
   </div>
  )
}

export default DeliveryTab